<app-split-pane
  storageKey="split.audit"
  [initialLeftRatio]="0.7"
  [collapseBreakpointPx]="1024"
  [collapsedOnSmallScreens]="true"
>
  <ng-container left>
    <app-split-pane-vertical storageKey="split.audit.left" [initialTopRatio]="0.7">
      <ng-container top>
        <app-chat [suggestions]="auditSuggestions" [context]="auditContext" placeholder="Ask about audit logs..."></app-chat>
      </ng-container>
      <ng-container bottom>
        <app-history scopeKey="audit.chat"></app-history>
      </ng-container>
    </app-split-pane-vertical>
  </ng-container>

  <ng-container right>
    <app-split-pane-vertical storageKey="split.audit.right" [initialTopRatio]="0.7">
      <ng-container top>
        <div class="page-workspace">
          <section class="card shadow-sm border-0 p-3 p-md-4">
            <h2 class="h4 mb-1">Audit Trails</h2>
            <p class="text-muted mb-3">Filter audit events and prepare traceable export context for operations review.</p>
            <h3 class="h5 mb-3">Audit Review Filters</h3>
            <div class="row g-3">
              <div class="col-md-3">
                <label class="form-label">Actor (optional)</label>
                <input class="form-control" [(ngModel)]="auditDraft.actor" placeholder="e.g. alex@company.com" />
              </div>
              <div class="col-md-3">
                <label class="form-label">Action type</label>
                <select class="form-select" [(ngModel)]="auditDraft.actionType">
                  <option value="">Select action...</option>
                  @for (option of actionTypeOptions; track option) {
                    <option [value]="option">{{ option }}</option>
                  }
                </select>
              </div>
              <div class="col-md-3">
                <label class="form-label">Time window</label>
                <select class="form-select" [(ngModel)]="auditDraft.timeWindow">
                  <option value="">Select window...</option>
                  @for (option of timeWindowOptions; track option) {
                    <option [value]="option">{{ option }}</option>
                  }
                </select>
              </div>
              <div class="col-md-3">
                <label class="form-label">Export reason (optional)</label>
                <input class="form-control" [(ngModel)]="auditDraft.exportReason" placeholder="e.g. Quarterly review" />
              </div>
            </div>
            <div class="mt-3">
              <button class="btn btn-primary" type="button" [disabled]="reviewingAudit" (click)="runAuditReview()">
                @if (reviewingAudit) {
                  <span class="spinner-border spinner-border-sm me-2"></span>
                  Running...
                } @else {
                  Run Audit Review
                }
              </button>
            </div>
            @if (auditError) {
              <div class="alert alert-danger mt-3 mb-0">{{ auditError }}</div>
            }
            @if (auditSuccess) {
              <div class="alert alert-success mt-3 mb-0">{{ auditSuccess }}</div>
            }
          </section>

          <section class="card shadow-sm border-0 p-3 p-md-4">
            <h3 class="h5 mb-3">Audit Summary</h3>
            @if (!hasReviewedAudit) {
              <div class="small text-muted">No audit review yet. Run review to populate summary.</div>
            } @else {
              <div class="summary-grid">
                <article class="summary-card">
                  <div class="summary-label">Actor</div>
                  <div class="summary-value">{{ auditDraft.actor.trim() || 'All actors' }}</div>
                </article>
                <article class="summary-card">
                  <div class="summary-label">Action type</div>
                  <div class="summary-value">{{ auditDraft.actionType }}</div>
                </article>
                <article class="summary-card">
                  <div class="summary-label">Time window</div>
                  <div class="summary-value">{{ auditDraft.timeWindow }}</div>
                </article>
                <article class="summary-card summary-card--full">
                  <div class="summary-label">Export reason</div>
                  <div class="summary-value">{{ auditDraft.exportReason.trim() || 'No export reason provided.' }}</div>
                </article>
              </div>
            }
          </section>
        </div>
      </ng-container>
      <ng-container bottom>
        <app-history scopeKey="audit.main"></app-history>
      </ng-container>
    </app-split-pane-vertical>
  </ng-container>
</app-split-pane>
